// Campus photo for /colleges/university-of-oklahoma: CC BY-SA 4.0, by Michael Barera, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUniversity_of_Oklahoma_July_2019_69_(Bizzell_Memorial_Library).jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-oklahoma/; credited under the photo.
const photo = {
    "slug": "university-of-oklahoma",
    "alt": "The front of Bizzell Memorial Library at the University of Oklahoma in Norman, Oklahoma",
    "src": "/colleges/university-of-oklahoma/campus-1600.webp",
    "srcSmall": "/colleges/university-of-oklahoma/campus-800.webp",
    "srcMid": "/colleges/university-of-oklahoma/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-oklahoma/og.jpg",
    "title": "University of Oklahoma July 2019 69 (Bizzell Memorial Library)",
    "author": "Michael Barera",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUniversity_of_Oklahoma_July_2019_69_(Bizzell_Memorial_Library).jpg",
    "read": "2026-10-01"
};

export default photo;
